import { Zap, Home, Pencil, Shirt, Megaphone, Printer, Wrench, Monitor, MoreHorizontal } from "lucide-react";
import { useTranslation } from "react-i18next";

const META = {
  servicios: { icon: Zap, chip: "bg-blue-100 text-blue-800 border-blue-200" },
  renta: { icon: Home, chip: "bg-purple-100 text-purple-800 border-purple-200" },
  papeleria: { icon: Pencil, chip: "bg-slate-100 text-slate-700 border-slate-200" },
  uniformes: { icon: Shirt, chip: "bg-rose-100 text-rose-800 border-rose-200" },
  marketing: { icon: Megaphone, chip: "bg-amber-100 text-amber-900 border-amber-200" },
  imprenta: { icon: Printer, chip: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  mantenimiento: { icon: Wrench, chip: "bg-orange-100 text-orange-800 border-orange-200" },
  software: { icon: Monitor, chip: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  otros: { icon: MoreHorizontal, chip: "bg-slate-100 text-slate-700 border-slate-200" },
};

export default function ExpenseCategoryBadge({ category, subcategory, size = "sm" }) {
  const { t } = useTranslation();
  const meta = META[category] || META.otros;
  const Icon = meta.icon;
  const label = t(`expense.categories.${category}`, { defaultValue: category });
  const subLabel = subcategory
    ? t(`expense.subcategories.${subcategory}`, { defaultValue: subcategory })
    : null;
  const px = size === "sm" ? "px-2 py-0.5" : "px-3 py-1";
  const txt = size === "sm" ? "text-[10px]" : "text-xs";
  return (
    <span
      data-testid={`expense-cat-${category}`}
      className={`inline-flex items-center gap-1 ${px} rounded-full ${txt} font-bold border ${meta.chip}`}
    >
      <Icon className="w-3 h-3" strokeWidth={2.4} />
      {label}
      {subLabel && <span className="opacity-70 font-semibold">· {subLabel}</span>}
    </span>
  );
}

export const EXPENSE_CATEGORY_META = META;
